module.exports = __webpack_public_path__ + "logo_2.png?d9bf473884f13568436b112839142ce3";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo_2.png
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22